import { IconMedia } from '../../../icons';

export function Logo() {
  return (
    <section className="footer__logo-section">
      <IconMedia icon="pixum_logo_dark" loading="lazy" alt="Pixum Logo" rootMarginIntersection="500px" />
    </section>
  );
}
